var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tutor__profile__img",class:("tutor__profile__img__" + (_vm.gender.toLowerCase())),style:({
    backgroundImage: _vm.profileImageUrl ? ("url('" + _vm.profileImageUrl + "')") : '',
  })})}
var staticRenderFns = []

export { render, staticRenderFns }